import ApiClient from '../ApiClient';

class CrmTrackingsAPI extends ApiClient {
    constructor() {
        super('crm/trackings', { accountScoped: true });
    }

    getTriggers(trackingId) {
        return axios.get(`${this.url}/${trackingId}/triggers`);
    }

    getApiKey() {
        return axios.get(`${this.url.replace('/trackings', '/tracking_api_key')}`);
    }

    regenerateApiKey() {
        return axios.post(`${this.url.replace('/trackings', '/regenerate_tracking_api_key')}`);
    }
}

export default new CrmTrackingsAPI();
